"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = (e) => {
    var _a;
    const analyticsEvent = {};
    const info = (e.target.getAttribute && ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.getAttribute('aria-label'))) || e.target.innerText;
    window.digitalData.component = [];
    window.digitalData.component.push({
        componentInfo: {
            componentID: '',
            componentName: '',
        },
        attributes: {
            position: '',
            listPosition: '',
            componentVariant: '',
        },
    });
    if (typeof window.ctConstants === 'undefined')
        return;
    analyticsEvent.eventInfo = {
        type: window.ctConstants.trackEvent,
        eventAction: window.ctConstants.imageload,
        eventValue: 1,
        eventLabel: `${info}`,
    };
    analyticsEvent.category = {
        primaryCategory: window.ctConstants.engagement,
    };
    analyticsEvent.subcategory = 'Interest';
    window.digitalData.event.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
